import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import LingxingSettings from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/lingxing'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'lingxing_settings_index',
          component: LingxingSettings,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
